import * as React from 'react';

import type {EmailAutomation as EmailAutomationFragment} from 'nutshell-graphql-types';

import {MAILCHIMP_EMAILS, NUTSHELL_EMAIL_MARKETING, CONSTANT_CONTACT_EMAILS} from '../../constants';
import type {EmailType} from '../../types';

import {SalesAutomationCardEmailConstantContact} from './email-marketing/sales-automation-card-email-constant-contact';
import {SalesAutomationCardEmailMailchimp} from './email-marketing/sales-automation-card-email-mailchimp';
import {SalesAutomationCardEmailNutshellSequenceTemplate} from './email-marketing/sales-automation-card-email-nutshell-sequence-template';
import {SalesAutomationStretchCard} from './sales-automation-stretch-card';

type Props = {
    emailAutomation: EmailAutomationFragment;
    isHidden: boolean;
    type: EmailType;
};

export class SalesAutomationCardEmail extends React.PureComponent<Props> {
    render() {
        return (
            <SalesAutomationStretchCard
                stageId={this.props.emailAutomation.entersStage.id}
                entityId={this.props.emailAutomation.id}
                type={this.props.type}
                isDisabled={!this.props.emailAutomation.emailList}
                isHidden={this.props.isHidden}
                size={this.props.type === NUTSHELL_EMAIL_MARKETING ? 'large' : 'small'}
                isFirstStage={this.props.emailAutomation.entersStage.position === 1}
                numberOfStagesSpanned={this.props.emailAutomation.numberOfStagesSpanned}
            >
                {this.renderButtonContents()}
            </SalesAutomationStretchCard>
        );
    }

    renderButtonContents = () => {
        switch (this.props.type) {
            case CONSTANT_CONTACT_EMAILS:
                return (
                    <SalesAutomationCardEmailConstantContact
                        emailAutomation={this.props.emailAutomation}
                    />
                );
            case NUTSHELL_EMAIL_MARKETING:
                return (
                    <SalesAutomationCardEmailNutshellSequenceTemplate
                        emailAutomation={this.props.emailAutomation}
                    />
                );
            case MAILCHIMP_EMAILS:
            default:
                return (
                    <SalesAutomationCardEmailMailchimp
                        emailAutomation={this.props.emailAutomation}
                    />
                );
        }
    };
}
